/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Online_Price_Error_RangeInputs */

const vi_online_price_error_range = /** @type {(inputs: Online_Price_Error_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Giá phải từ 1 đến ${i?.max} đồng`)
};

/**

* @param {Online_Price_Error_RangeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const online_price_error_range = /** @type {((inputs: Online_Price_Error_RangeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Online_Price_Error_RangeInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_online_price_error_range(inputs)
});